// extracted by mini-css-extract-plugin
module.exports = {"response":"Response_response__LjB37","inner":"Response_inner__-X6k9"};